import React from "react"

function ChatBubble({ width = 24, height = 24, fill = "none", ...props }) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="6 6 24 24"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M18 8C12.5 8 8 12.5 8 18C8 23.5 12.5 28 18 28H27.5V17.4C27.2 12.6 22.8 8 18 8Z"
        stroke="#003E4C"
        strokeWidth="0.75"
      />
      <path d="M13.8 14.7H18.8" stroke="#003E4C" strokeWidth="0.75" />
      <path d="M13.8 18H22.2" stroke="#003E4C" strokeWidth="0.75" />
      <path d="M13.8 21.3H22.2" stroke="#003E4C" strokeWidth="0.75" />
    </svg>
  )
}
export default ChatBubble
